import React, { Component } from 'react';
import { connect } from 'react-redux'
import ProductCard from './product-card';
import TextInfo from '@gerenciatd/next.components.text-info-n';
import Button, { BUTTON_WIDTH } from '@gerenciatd/next.components.button-n';

const MAIN_TAGGING_INFO = {
  componentName: 'configuradortv',
  componentContent: 'Ver soluciones',
  componentVariation: '',
  componentProduct: '',
}

class ProductSuggest extends Component {
  constructor(props){
    super(props);
    this.state = {
      selectedMap: {
        1: false,
        2: false,
        3: false,
      },
    }
  }
  handleClick = (id) => {
    const { selectedMap } = this.state;
    const newValue = !selectedMap[id];
    this.setState({
      selectedMap:{
        ...selectedMap,
        [id]: newValue,
      }
    })
  }

  getLinkBySelected = () => {
    let hrefObject = null;
    let href = null;
    const { combinations, context, singleSelection } = this.props;
    const logged = context && context.userType !== ''
    const { selectedMap } = this.state;
    const selectedMapKeys = Object.keys(selectedMap);

    const selectedValues = [];
    const numberOfSelected = selectedMapKeys.filter((key) => {
      const value = selectedMap[key];
      let selectedRes = !!value;
      if(selectedRes){
        selectedValues.push(parseInt(key))
      }
      return selectedRes;
    }).length;

    if (numberOfSelected === 1) {
      let currentSelected = 0;
      selectedMapKeys.forEach(keyName => {
        const currentValue = selectedMap[keyName]
        if(currentValue){
          currentSelected = parseInt(keyName, 10);
        }
      })
      if(currentSelected){
        hrefObject = singleSelection.find(item => item.id1 === currentSelected);
      }
    }

    if (numberOfSelected === 2){
      let ocurrence = combinations.filter((combo) => {
        const satisfyContitions = 
          (
            (combo.id1 === selectedValues[0] && combo.id2 === selectedValues[1]) ||
            (combo.id1 === selectedValues[1] && combo.id2 === selectedValues[0])
          ) && !combo.id3
        return satisfyContitions;
      });
      if (ocurrence  && ocurrence.length > 0){
        ocurrence = ocurrence[0];
        hrefObject = {
          link: ocurrence.link,
          loggedLink: ocurrence.loggedLink
        }
      }
    }

    if (numberOfSelected === 3) {
      let ocurrence = [];
      combinations.forEach((combo) => {
        let is3Combo = (combo && combo.id3) ? true : false;
        if(is3Combo) {
          ocurrence.push(combo);
        }
      });
      if (ocurrence  && ocurrence.length > 0){
        ocurrence = ocurrence[0];
        hrefObject = {
          link: ocurrence.link,
          loggedLink: ocurrence.loggedLink
        }
      }
    }


    // decidimos si es logado o no para elegir un enlace u otro
    if(hrefObject) {
      if (logged) {
        href = hrefObject.loggedLink;
      } else {
        href = hrefObject.link;
      }
    }

    return href;
  }

  render(){
    const { selectedMap } = this.state;
    const { custoObjectInfo } = this.props;
    let textInfoCustoObjectInfo1 = null;
    const href = this.getLinkBySelected();
    if (custoObjectInfo) {
      textInfoCustoObjectInfo1 = custoObjectInfo.addEntryPoint({
        custoObjectInfo,
        entryPoint: 'TextInfo-1',
      })
    }
  
    return (
      <div className="container">
        <div className="ProductSuggest">
          {this.props['TextInfo-1'] && (
            <TextInfo {...this.props['TextInfo-1']} custoObjectInfo={textInfoCustoObjectInfo1} />
          )}
          <div className="ProductContainer">
            {this.props['ProductCard-1'] && (
              <ProductCard
                id={1}
                selected={selectedMap[1]}
                {...this.props['ProductCard-1']}
                custoObjectInfo={ custoObjectInfo ? custoObjectInfo.addEntryPoint({
                  custoObjectInfo,
                  entryPoint: 'ProductCard-1',
                }): null}
                onClick={this.handleClick}
              />
            )}
            {this.props['ProductCard-2'] && (
              <ProductCard
                id={2}
                selected={selectedMap[2]}
                {...this.props['ProductCard-2']} 
                  custoObjectInfo={ custoObjectInfo ? custoObjectInfo.addEntryPoint({
                  custoObjectInfo,
                  entryPoint: 'ProductCard-2',
                }): null}
                onClick={this.handleClick}
              />
            )}
            {this.props['ProductCard-3'] && (
              <ProductCard
                id={3}
                selected={selectedMap[3]}
                {...this.props['ProductCard-3']} 
                custoObjectInfo={ custoObjectInfo ? custoObjectInfo.addEntryPoint({
                  custoObjectInfo,
                  entryPoint: 'ProductCard-3',
                }): null}
                onClick={this.handleClick}
              />
            )}
          </div>
          <div className="ButtonGap">
            {href && (
              <Button
                href={href}
                taggingInfo={MAIN_TAGGING_INFO}
                buttonWidth={BUTTON_WIDTH.DEFAULT}
                label="Ver soluciones"
              />
            )}
            {!href && (
              <Button
                disabled={true}
                onClick={() => {}}
                taggingInfo={MAIN_TAGGING_INFO}
                buttonWidth={BUTTON_WIDTH.DEFAULT}
                label="Ver soluciones"
              />
            )}
          </div>
        </div>
        <style jsx>
          {`
            .ProductSuggest {
              padding: 3rem 0px;
              margin-bottom: 3rem;
              .ProductContainer{
                margin: 2rem auto 2rem auto;
                display: flex;
                width:100%;
                flex-wrap: wrap;
                justify-content: space-between;
                align-items: stretch;
              }
              .ButtonGap{
                margin: 0 auto;
                min-height: 3rem;
                max-width: 11.25rem;
                width: 100%;
                :global(a){
                  width: 100%;
                }
                :global(button){
                  width:100%;
                }
              }
            }
            @media screen and (max-width: 1200px){
              .ProductSuggest {
                .ProductContainer {
                  flex-direction:column;
                  align-items: center;
                }
              }
            }
            @media screen and (max-width: 968px) {
              .ProductSuggest{
                  padding: 2rem 0px;
              }
            }
            @media screen and (max-width: 500px) {
              .ProductSuggest{
                padding: 2rem 0px;
              }
            }
          `}
        </style>
      </div>
    )
  }
} 


const mapStateToProps = (state) => ({
  context: state.main.context,
});


export default connect(mapStateToProps, null)(ProductSuggest)
